<form
  #setPhoneForm="ngForm"
  (ngSubmit)="submit(setPhoneForm)"
  novalidate
>
  <div
    *ngIf="askCurrentPassword"
    class="mb-3"
    [podValidationClass]="password"
  >
    <label
      for="password"
      class="form-label"
    >{{'label.currentPassword' | translate}}</label>
    <input
      type="password"
      class="form-control"
      id="password"
      name="password"
      [(ngModel)]="model.password"
      #password="ngModel"
      required
    />
    <pod-validation-messages
      [model]="password"
      fieldName="{{'label.currentPassword' | translate}}"
    ></pod-validation-messages>
  </div>
  <div
    class="mb-3"
    [podValidationClass]="phoneNumber"
  >
    <label
      for="phoneNumber"
      class="form-label"
    >{{'label.phoneNumber' | translate}}</label>
    <pod-intl-tel-input
      id="phoneNumber"
      name="phoneNumber"
      [(ngModel)]="model.phoneNumber"
      #phoneNumber="ngModel"
      required
    ></pod-intl-tel-input>
    <pod-validation-messages
      [model]="phoneNumber"
      fieldName="{{'label.phoneNumber' | translate}}"
    ></pod-validation-messages>
  </div>
  <div [ngClass]="{'d-flex justify-content-around align-items-center': !blockButtons, 'd-grid gap-3': blockButtons}">
    <button
      type="submit"
      class="btn btn-tertiary"
      [disabled]="submitting"
      id="set-2fa-submit"
    >
      {{ (submitting ? 'label.saving...' : ( user ? 'label.changeMobileNumber' : 'label.verifyNumber')) | translate}}
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="onCancel.emit()"
      id="set-2fa-cancel"
    >{{'label.cancel' | translate}}</button>
  </div>
</form>